import Accordion from 'components/accordion';
import AccordionItem from 'components/accordion/AccordionItem';
import { quickLinks } from 'pages/admin/dashboardPage/configs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const DashboardPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Accordion>
      <AccordionItem itemKey={0} label={t('admin.label.quick_access')}>
        <ul className='grid w-full grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-6'>
          {quickLinks.map((item) => (
            <li key={item.link} className='w-full'>
              <Link
                to={item.link}
                className='block flex h-full w-full items-center justify-center rounded-md border border-[#eee] px-6 py-7 text-center font-semibold uppercase shadow-lg hover:bg-hl-beige-50 hover:text-hl-primary'
              >
                {t(item.label)}
              </Link>
            </li>
          ))}
        </ul>
      </AccordionItem>
    </Accordion>
  );
};

export default DashboardPage;
